import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Container, Typography } from '@material-ui/core';
import RegularButton from 'components/CustomButtons/Button';
import RestoreIcon from '@material-ui/icons/Restore';
import BugReportIcon from '@material-ui/icons/BugReport';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '400px',
    height: '100%',
    textAlign: 'center',
    padding: theme.spacing(3),
  },
  icon: {
    fontSize: '6rem',
    color: theme.palette.error.main,
    marginBottom: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(1),
    fontWeight: 600,
  },
  message: {
    marginBottom: theme.spacing(4),
    color: theme.palette.text.secondary,
    maxWidth: '600px',
  },
  button: {
    marginTop: theme.spacing(2),
  },
}));

const ErrorFallback = ({ resetErrorBoundary }) => {
  const classes = useStyles();

  return (
    <Container className={classes.root}>
      <BugReportIcon className={classes.icon} />
      <Typography variant="h4" component="h1" className={classes.title}>
        ¡Ups! Algo salió mal.
      </Typography>
      <Typography variant="body1" className={classes.message}>
        Hemos detectado un error inesperado. Nuestro equipo ha sido notificado.
        Por favor, intenta recargar la página.
      </Typography>
      <RegularButton
        color="info"
        onClick={resetErrorBoundary}
        className={classes.button}
      >
        <RestoreIcon style={{ marginRight: 8 }} />
        Intentar de nuevo
      </RegularButton>
    </Container>
  );
};

export default ErrorFallback;
